import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Workspace } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0100. ワークスペース一覧
 * [GET] /workspaces
 */
const workspaces = (): Promise<Workspace[]> => {
  return axios.get(`/api/workspaces`);
};

export const useWorkspaces = () => {
  return useQuery({
    queryKey: ['workspaces'],
    queryFn: () => workspaces(),
  });
};

export const useWorkspacesInvalidate = () => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: ['workspaces'] });
  };

  return { invalidate };
};
